import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux"
import { CompaniesYouFollow } from "../../../components/admin/Dashboard/dashboard/CompaniesYouFollow";
import { WelcomeBanner } from "../../../components/admin/Dashboard/dashboard/WelcomeBanner";
import { Insights } from "../../../components/admin/Dashboard/dashboard/Insights";
import { PurchasedCompany } from "../../../components/admin/Dashboard/dashboard/PurchasedCompany";
import { VerificationBanner } from "../../../components/admin/Dashboard/dashboard/VerificationBanner";
import BusinessProfileWidget from "../../../components/public/Search/BusinesProfileWidget";
import { useGenerateSumsubUrlMutation, useGetUserVerificationStatusQuery } from "../../../store/auth/usersApiSlice";
import { CommonToast } from "../../../components/common/Toast";
// import PaymentReferencesHubSection from "../../../components/admin/Dashboard/PaymentReferencesHubSection";

function Dashboard() {
  const { userInfo, token } = useSelector((state) => state.auth);
  const { data, isLoading, refetch } = useGetUserVerificationStatusQuery(token);
  const [status, setStatus] = useState("NOT_REQUIRED")

  useMemo(() => {
    if (data?.status) {
      setStatus(data.status)
    }
  }, [data?.status]);

  const [generateSumsubUrl] = useGenerateSumsubUrlMutation();

  const getUrl = async () => {
    try {
      const response = await generateSumsubUrl(token);
      if (response?.data?.verification_url) {
        window.open(response.data.verification_url.url, '_blank');
      }else{
        CommonToast.error(response?.error?.data?.messages[0].message ?? "Something went wrong");
      }
    } catch (error) {
      CommonToast.error(error?.message ?? "Something went wrong")
    }
  }

  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          {(status === "PENDING" || status === "FAILED" || status === "IN_PROGRESS") && <VerificationBanner getUrl={getUrl} status={status} />}
          <WelcomeBanner />
          <CompaniesYouFollow />
          <PurchasedCompany />
          {/* <PaymentReferencesHubSection/> */}
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col">
          <BusinessProfileWidget />
          <Insights />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
